var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collection-list-item"},[_c('img',{staticClass:"image",attrs:{"src":_vm.imageUrl}}),_vm._v(" "),_c('div',{staticClass:"meta"},[_c('router-link',{staticClass:"name",attrs:{"to":_vm.route}},[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.packageCountText))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }